import { createContext } from "preact";
import { useContext } from "preact/hooks";
import {
    makeApi,
    makeBreadcrumbs,
    makeDialog,
    makeHelp,
    makeI18n,
    makeMeta,
    makeMobile,
    makeSearch,
    makeSettings,
    makeShare,
    makeSnack,
    makeStatus,
    makeTracker,
} from "./slices";

const createAppStore = () => {
    const api = makeApi();
    const breadcrumbs = makeBreadcrumbs();
    const dialog = makeDialog();
    const help = makeHelp({ api });
    const i18n = makeI18n();
    const meta = makeMeta();
    const mobile = makeMobile();
    const search = makeSearch();
    const settings = makeSettings({ api });
    const share = makeShare();
    const snack = makeSnack();
    const status = makeStatus({ api });
    const tracker = makeTracker({ api });

    return {
        api,
        breadcrumbs,
        dialog,
        help,
        i18n,
        meta,
        mobile,
        search,
        settings,
        share,
        snack,
        status,
        tracker,
    };
};

export const store = createAppStore();

const context = createContext<typeof store | null>(null);

export const AppProvider = context.Provider;

export const useApp = () => {
    const state = useContext(context);

    if (!state) {
        throw new Error("There's no Provider for App Context");
    }

    return state;
};

// @TODO: rename?
export const me = (path: string) =>
    `/me/${store.api.installation.value}/${store.api.company.value}/${path}`;
